import { atom } from 'jotai';

// 当前活动的Tab
export type TabType = 'tasks' | 'projects' | 'chat' | 'me' | 'calendar';
export const activeTabAtom = atom<TabType>('tasks');

// 全局加载状态
export const globalLoadingAtom = atom<boolean>(false);

// 后台刷新状态 - 用于显示小型加载指示器而不是全屏加载状态
export const backgroundRefreshingAtom = atom<boolean>(false);

// 上次数据加载时间
export const lastDataRefreshAtom = atom<Record<string, number>>({
  tasks: 0,
  projects: 0,
  chat: 0,
  profile: 0
});

// 是否应该使用缓存优先策略
export const useCacheFirstAtom = atom<boolean>(true);

// 翻译功能相关原子
export const translationEnabledAtom = atom<boolean>(false);
export const translationLanguageAtom = atom<string>('ru'); // 默认翻译为俄语

// 翻译缓存原子
export interface TranslationCache {
  [key: string]: string; // key: translation_${lang}_${contentType}_${id}, value: translated text
}

export const translationCacheAtom = atom<TranslationCache>({});

// 加载翻译缓存
export const loadTranslationCacheAtom = atom(
  null,
  (get, set) => {
    try {
      const cached = localStorage.getItem('translation_cache');
      if (cached) {
        set(translationCacheAtom, JSON.parse(cached));
      }
    } catch (error) {
      console.error('Failed to load translation cache:', error);
    }
  }
);

// 保存翻译缓存
export const saveTranslationCacheAtom = atom(
  null,
  (get, set) => {
    try {
      const cache = get(translationCacheAtom);
      localStorage.setItem('translation_cache', JSON.stringify(cache));
    } catch (error) {
      console.error('Failed to save translation cache:', error);
    }
  }
);

// Toast消息状态
export interface ToastMessage {
  id: string;
  title: string;
  description?: string;
  status: 'info' | 'success' | 'warning' | 'error';
  duration?: number;
  isClosable?: boolean;
}

export const toastMessagesAtom = atom<ToastMessage[]>([]);

// 添加Toast消息函数
export const addToastAtom = atom(
  null,
  (get, set, toast: Omit<ToastMessage, 'id'>) => {
    const id = Math.random().toString(36).substring(2, 9);
    const newToast = {
      ...toast,
      id,
      duration: toast.duration || 3000,
      isClosable: toast.isClosable !== false
    };
    set(toastMessagesAtom, [...get(toastMessagesAtom), newToast]);

    // 自动移除Toast
    setTimeout(() => {
      set(toastMessagesAtom, get(toastMessagesAtom).filter(t => t.id !== id));
    }, newToast.duration);
  }
);

// 移除Toast消息函数
export const removeToastAtom = atom(
  null,
  (get, set, id: string) => {
    set(toastMessagesAtom, get(toastMessagesAtom).filter(t => t.id !== id));
  }
);

// 模态框状态
export const modalOpenAtom = atom<boolean>(false);
export const modalTypeAtom = atom<string | null>(null);
export const modalDataAtom = atom<unknown>(null); 